import { DeviceSize } from '@frontend/device-size-field';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BaseFieldProps, Button, Modal, ModalControlModalProps } from '@frontend/design-system';

type Props = {
  deviceSizeProps: BaseFieldProps<DeviceSize>;
  modalProps: ModalControlModalProps;
  previewHtml?: string;
  createNewFaxWithTemplate: () => void;
};

export const TemplatePreviewModal = ({ deviceSizeProps, modalProps, previewHtml, createNewFaxWithTemplate }: Props) => {
  const { t } = useTranslation('fax');

  const modalSizeStyle = {
    height: 1000,
    maxHeight: '80vh',
    width: deviceSizeProps.value === 'desktop' ? 'max(648px,100%)' : 'max(480px,100%)',
    minWidth: deviceSizeProps.value === 'desktop' ? 'min(648px,100%)' : 'min(480px,100%)',
    maxWidth: '60vw',
    padding: theme.spacing(0, 1, 1, 1),
  };

  return (
    <Modal
      {...modalProps}
      css={[
        { borderRadius: 0, border: 0, padding: 0, boxShadow: theme.shadows.floating, overflow: 'visible' },
        modalSizeStyle,
      ]}
    >
      <Button
        label='use-this-template-button'
        variant='primary'
        css={{ position: 'absolute', top: theme.spacing(-6), right: 40 }}
        onClick={createNewFaxWithTemplate}
      >
        {t('Use This Template')}
      </Button>
      <Button
        label='close-template-preview-button'
        variant='secondary'
        css={{ position: 'absolute', top: theme.spacing(-6), backgroundColor: theme.colors.white, right: 0 }}
        onClick={() => {
          modalProps.onClose();
        }}
        iconName='x'
      />
      <iframe
        title={t('Template Preview')}
        srcDoc={previewHtml}
        sandbox='allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox'
        css={[{ border: 0 }, modalSizeStyle]}
      />
    </Modal>
  );
};
